import { AdminHealthOverview } from '@activepieces/shared';

import { STUCK_ACTIVE_JOB_TIMEOUT_MULTIPLIER } from './constants';

type HealthQueue = AdminHealthOverview['queues'][number];

// Summing the queues hides which one is stuck: the tiles show the single
// worst queue, and name it.
const queueWithOldestJob = (
  queues: HealthQueue[],
  ageOf: (queue: HealthQueue) => number,
): HealthQueue | null =>
  queues.reduce<HealthQueue | null>(
    (oldest, queue) =>
      oldest === null || ageOf(queue) > ageOf(oldest) ? queue : oldest,
    null,
  );

// The age of the oldest waiting job is the metric that signals saturation —
// it is the one driving the autoscaling policy and the capacity alarm.
export const oldestWaitingQueue = (queues: HealthQueue[]): HealthQueue | null =>
  queueWithOldestJob(
    queues.filter((queue) => queue.jobsWaiting > 0),
    (queue) => queue.oldestJobAgeSeconds,
  );

export const longestRunningQueue = (
  queues: HealthQueue[],
): HealthQueue | null =>
  queueWithOldestJob(
    queues.filter((queue) => queue.jobsActive > 0),
    (queue) => queue.oldestActiveJobAgeSeconds,
  );

export const stuckActiveJobThresholdSeconds = (
  config: AdminHealthOverview['runtimeConfig'],
): number =>
  STUCK_ACTIVE_JOB_TIMEOUT_MULTIPLIER *
  Math.max(config.flowTimeoutSeconds, config.triggerTimeoutSeconds);
